import ApiService from '@/services/api.service'

const MedicationInboxService = {
    getAll( parameter) {          
      const requestData = {
        method: 'get',
        url: "/MedicationInbox/",
        headers: {
        },
        params: { 
          SearchCriteria: parameter.SearchCriteria,
          DateFrom: parameter.DateFrom,
          DateTo: parameter.DateTo,
          Status: parameter.Status,
          ProgramCode: parameter.ProgramCode,
          PatientCode: parameter.PatientCode,
          BuildingCode: parameter.BuildingCode,
          LevelCode: parameter.LevelCode,
          RoomCode: parameter.RoomCode,
          PrescriberCode: parameter.PrescriberCode,
          RxStatus: parameter.RxStatus,
          IsInpatient:parameter.IsInpatient,
          BuildingRestriction: parameter.BuildingRestriction,
          ProgramsRestriction: parameter.ProgramsRestriction?.join(',') || ''
        }
      }     
      return ApiService.customRequest(requestData);         
    },

    SetStatus(recordIds){
        return ApiService.post(`/MedicationInbox`,recordIds)
    },
}
  
  export default MedicationInboxService;